<div
  *ngIf="hasFilters && (items?.size >= 0 || forceDisplayFilters)"
  class="filters-wrapper"
>
  <div *ngIf="filterTotalsLabel" class="filters-totals-wrapper">
    <span class="filters-totals-label"> {{ filterTotalsLabel }}: </span>

    <ng-container [ngSwitch]="fetchingFilterTotals || filterTotals === null">
      <app-icon
        *ngSwitchCase="true"
        class="loading-icon"
        data-e2e-id="list-filter-totals-spinner"
        [icon]="loadingSpinnerIcon"
      >
      </app-icon>

      <span
        *ngSwitchDefault
        class="filters-totals"
        data-e2e-id="list-filter-totals"
      >
        {{ filterTotals }}
      </span>
    </ng-container>
  </div>

  <div
    *ngIf="(filterControl && !!filterOptions) || filterCtaLabel"
    class="filters-wrapper"
  >
    <button
      *ngIf="filterCtaLabel"
      i2gButton
      buttonStyle="tertiary"
      class="filter-cta"
      [disabled]="disableFilterCta"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="filterCtaTrackingAction"
      [trackingAdditionalProperties]="trackingAdditionalProperties"
      (click)="!disableFilterCta && onFilterCta.emit()"
    >
      {{ filterCtaLabel }}
    </button>

    <app-select-field
      *ngIf="filterControl && !!filterOptions"
      class="filter-options"
      [hideLabel]="true"
      [formControl]="filterControl"
      [values]="filterOptions"
      [blocker]="filterBlocker"
      [trackingObject]="trackingObject"
      [trackingTapped]="filterButtonTapped"
      [trackingAdditionalProperties]="filterTrackingAdditionalProperties"
      [trackingSelected]="filterDropdownSelected"
    >
    </app-select-field>
  </div>
</div>

<ng-container [ngSwitch]="!loading || !!headers">
  <ng-container *ngSwitchCase="true">
    <div *ngIf="headers?.size > 0 && items?.size > 0" class="headers">
      <div class="main-headers">
        <div
          *ngIf="enableBulkActions"
          class="header bulk-action-placeholder"
        ></div>

        <div
          *ngFor="let header of headers"
          class="header"
          [ngClass]="[
            header.customClass || '',
            header.sortBy === undefined || header.disableSorting
              ? ''
              : 'sortable',
            sortByHeader && header.sortBy === sortByHeader.sortBy
              ? 'sorting'
              : ''
          ]"
          trackable
          [trackingObject]="header.trackingObject"
          [trackingAction]="header.trackingAction"
          [trackingAdditionalProperties]="header.trackingAdditionalProperties"
          (click)="toggleSorting(header)"
        >
          {{ header.label }}

          <app-icon
            class="sorted-by-icon"
            [ngClass]="sortByHeader?.sortOrder || null"
            [icon]="chevronDownIcon"
          >
          </app-icon>
        </div>
      </div>

      <div class="action-placeholder"></div>
    </div>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <div *ngIf="headers" class="headers placeholder-headers">
      <div class="placeholder-header col-1">
        <div class="shimmer"></div>
      </div>

      <div class="placeholder-header col-2">
        <div class="shimmer"></div>
      </div>

      <div class="placeholder-header col-3">
        <div class="shimmer"></div>
      </div>
    </div>
  </ng-container>
</ng-container>

<app-premium-banner
  *ngIf="showPremiumBanner"
  class="premium-banner"
  (onClick)="showFeatureHighlightDialog()"
>
</app-premium-banner>

<app-feed
  [feed]="items"
  [noItemsOptions]="noItemsOptions"
  [groupByFn]="groupByFn"
  [sortGroupsByFn]="sortGroupsByFn"
  [sortGroupsComparator]="sortGroupsComparator"
  [groupMetadata]="groupMetadata"
  [trackByFn]="trackByFn"
  [fetching]="fetchingList"
  [lastPageFetched]="lastPageFetched"
  [enablePagination]="enablePagination"
  [enableVirtualScroll]="true"
  [displayEmptyGroups]="displayEmptyGroups"
  (onInfinitePagination)="onInfinitePagination.emit()"
  (onNoItemsPrimaryActionClick)="onNoItemsPrimaryActionClick.emit()"
>
  <ng-template let-entity="feedItem" let-position="position">
    <ng-container
      *ngTemplateOutlet="
        template;
        context: { entity: entity, position: position }
      "
    ></ng-container>
  </ng-template>
</app-feed>
